'use client';

import Header from '@/components/common/Header';

import PriceListInteractive from './components/PriceListInteractive';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';
import FooterWrapper from '@/components/common/FooterWrapper';

export default function PriceListPage() {
  const { t } = useLanguage();

  return (
    <>
      <Header />
      <main className="min-h-screen bg-secondary relative overflow-hidden">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-primary/5 to-secondary py-12 md:py-16 relative z-10">
          <div className="mx-auto max-w-content px-5">
            <div className="max-w-3xl">
              <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4">
                {t('priceList.title')}
              </h1>
              <p className="font-body text-lg text-foreground/80 leading-relaxed">
                {t('priceList.subtitle')}
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-12 md:py-16">
          <div className="mx-auto max-w-content px-5">
            <PriceListInteractive />
          </div>
        </section>

        {/* Features Section */}
        <section className="py-12 md:py-16 bg-muted/30">
          <div className="mx-auto max-w-content px-5">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-card rounded-lg p-6 shadow-elevation-sm">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center mb-4">
                  <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-accent" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
                  {t('priceList.features.quality.title')}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t('priceList.features.quality.description')}
                </p>
              </div>

              <div className="bg-card rounded-lg p-6 shadow-elevation-sm">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center mb-4">
                  <Icon name="ArrowPathIcon" size={24} variant="solid" className="text-accent" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
                  {t('priceList.features.daily.title')}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t('priceList.features.daily.description')}
                </p>
              </div>

              <div className="bg-card rounded-lg p-6 shadow-elevation-sm">
                <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center mb-4">
                  <Icon name="ArrowTrendingUpIcon" size={24} variant="solid" className="text-accent" />
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground mb-2">
                  {t('priceList.features.buyback.title')}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {t('priceList.features.buyback.description')}
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <FooterWrapper />
    </>
  );
}